// que dios me bendiga por haber iniciado a trabajar con un svg tan grande.
import {useState} from 'react'

import { Box, Image } from "@chakra-ui/react";

import Bazo from "./Organos/Bazo";
import Cerebro from "./Organos/Cerebro";
import Corazon from "./Organos/Corazon";
import Estomago from "./Organos/Estomago";
import Higado from "./Organos/Higado";
import IntestinoD from "./Organos/IntestinoD";
import IntestinoG from "./Organos/IntestinoG";
import Pancreas from "./Organos/Pancreas";
import Pulmon from "./Organos/Pulmon";
import Riñon from "./Organos/Riñon";
import Vejiga from "./Organos/Vejiga";


import Muerte1 from './../../static/muerte1.jpg'
import Muerte2 from './../../static/muerte2.jpg'

/*

    TODO 

    MOBILE SUPPORT

*/
const Organos = () => {
    const [organ, setOrgan] = useState("") 

    const organName = (name) => {
        setOrgan(name)
    }

    return (<Box
    >
        <Box>seleccionado = {organ}</Box>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 297 210">

        <Pancreas
            onMouseEnter={()=>{organName("Higado")}}
        />
        <Bazo
            onMouseEnter={()=>{organName("Bazo")}}
        />
        <Estomago
            onMouseEnter={()=>{organName("Estomago")}}
        />
        <Higado
            onMouseEnter={()=>{organName("Higado")}}
        />
        <Pulmon
            onMouseEnter={()=>{organName("Pulmon")}}
        />
        <IntestinoD
            onMouseEnter={()=>{organName("IntestinoD")}}
        />
        <Corazon
            onMouseEnter={()=>{organName("Corazon")}}
        />
        <Vejiga
            onMouseEnter={()=>{organName("Vejiga")}}
        />
        <IntestinoG
            onMouseEnter={()=>{organName("IntestnioG")}}
        />
        <Cerebro
            onMouseEnter={()=>{organName("Cerebro")}}
        />
        <Riñon
            onMouseEnter={()=>{organName("Riñon")}}
        />

        <g
            // cabeza y cuerpo
        >
            <path
            d="M137.512 14.14l7.67.627 1.879 3.13-.705 6.223.861.821-.782 5.166-1.41.86-1.33 5.205-2.191 2.231-3.522 1.096-2.661.039-4.109-1.213-1.252-1.996-1.018-3.835-.47-1.8-.938-.626.078-3.914 1.017.04-.587-5.988.94-2.582 3.208-2.661z"
            fill="#fad9c9"
            fill-opacity=".373"
            stroke="#fca1c8"
            stroke-width=".285"
            stroke-miterlimit="3.9"
            />
            <path
                d="M148.133 88.056l-.178 4.792 1.775 8.874 2.189 21.67.355 14.198.355 5.147-1.243 2.485-.887 10.648-3.904 17.57 1.597 2.307 9.875.505 1.993.362.74.856-.895.23 1.065.71.548.865-.725 1.442-1.07.39-1.77.142-1.597-.71-4.792.71-4.614-1.242-3.195.71-3.195-.355-1.242-2.308 1.065-4.081.887-4.26-1.242-14.908 2.84-10.293.355-3.905-6.39-16.86-1.597-10.294-1.065 1.065-1.42 13.666-5.324 17.392 1.775 7.277-.177 4.437-2.663 12.246-.532 6.566.486 4.343-.131 1.874-.92 1.818-1.151.2-1.093-.47-.014-1.458-.922 1.303-1.007-.4.496-1.144-.965.997-.793-.507.23-.774-1.042.336-.955-.498-.458-.855 1.107-2.381 1.985-2.561.355-7.454-1.58-9.687.87-13.562.05-2.829-1.292-5.335v-14.376l1.242-12.246.71-9.76.71-6.212 1.065-11.359-1.268-9.09-2.814-8.657-1.065 4.437-5.502 13.133-2.84 7.099-1.597 11.536-2.307 7.631.71 3.372 4.437 3.55-.355.71-4.082-2.485 1.42 3.904 1.775 1.953-.888 1.064-2.84-3.194 1.953 3.904-1.242 1.243-2.308-4.792 1.065 3.55-.887.71-2.13-3.905.178-4.97-1.243 4.26-.177 2.307-1.242-.532v-6.922l1.242-4.082.532-5.68.178-11.535 2.13-6.922.887-9.76 7.809-19.878 2.13-7.276 5.324-3.55 6.744-.355 4.614-3.017.178-2.485 3.976 1.104 2.966-.035 3.24-.974 1.176 3.1 2.662 1.065 3.372-.355 3.3.25 3.8 3.832 1.774 6.034 7.809 16.505 1.952 12.423 2.13 4.792-.355 9.052-1.77 10.82.306 1.558.843 1.02 1.87 2.097 1.515 2.823 1.12 2.792-1.49.085-1.282-1.543-.904-1.769-.508.28.566 2.069.444 2.484-.819 4.737-1.1 2.064-.799-.71.173-2.978-1.836 3.3-.691-.245-.075-1.02.997-2.848-.154-2.377-.622 3.114-.633 2.259-.871-.77.13-1.813.768-3.183-.325-1.127-.57 2.08-.531 3.018-.815-.276.338-3.904.537-2.23-.024-3.125-.177-2.307-.178-2.307.355-2.84-1.952-7.809-.71-7.276v-5.502l-3.55-6.034-3.194-9.761-1.42-1.775-1.42 6.744-1.3 9.566z"
                fill="#fadbc9"
                fill-opacity=".372"
                stroke="#fca1c8"
                stroke-width=".3"
                stroke-miterlimit="3.9"
            />
        </g>
    </svg>

    <Image alt="muerte1" src={Muerte1}/>
    <Image alt="muerte2" src={Muerte2}/>

    </Box>)
}

export default Organos